import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import useConfig from 'common/hooks/useConfig';

import { PREMIUM_PRODUCT_KEYS } from './constants';
import HubspotEmbed from './HubspotEmbed';

const PremiumRoute = ({ productKey, children, ...routeProps }) => {
  const config = useConfig();
  const isProductEnabled = config.isConfigEnabled(productKey);

  return (
    <Route {...routeProps}>
      {isProductEnabled && <Switch>{children}</Switch>}
      {!isProductEnabled && <HubspotEmbed productKey={productKey} />}
    </Route>
  );
};

PremiumRoute.propTypes = {
  productKey: PropTypes.oneOf(Object.values(PREMIUM_PRODUCT_KEYS)).isRequired,
  children: PropTypes.node.isRequired,
};

export default PremiumRoute;
